export const menuCoordenador = [
  { label: "Meus Cursos", path: "/cursos" },
  { label: "Minhas Turmas", path: "/turmas" },
  { label: "Professores", path: "/professores" },
  { label: "Disciplinas", path: "/disciplinas" },
  { label: "Meus Dados", path: "/meus-dados" }

];
